import { GroupedByBrandShelfTalkerCardData } from './grouped-by-brand-shelf-talker-card-data';

export class GlassHouseShelfTalkerCardData extends GroupedByBrandShelfTalkerCardData {}
